export default __webpack_public_path__ + "static/media/undraw_remote_meeting_re_abe7.b049edf6.svg";